<template>
  <div>
    <ams-search
      heading="Product Information"
      :ams_type="ams_type"
      :ams_fields="ams_fields"
      @searchFor="searchSelection"
    ></ams-search>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
      <b-col md="4" class="my-1">
        <b-button variant="outline-primary"
          size="sm" @click="addEntry"
          v-b-tooltip.hover.right title="Add Entry"
        >
          <b-icon-plus-circle-fill> aria-label="Add Entry"></b-icon-plus-circle-fill>
        </b-button>
      </b-col>
    </b-row>
    <b-card bg-variant="light">
      <b-card-group deck>
        <div v-for="(item) in items" :key="item.id" class="col-xs-6 col-sm-4 col-md-4">
          <b-button-group>
            <b-button size="sm"
              variant="primary" 
              class="mb-2"
              v-b-tooltip.hover.top title="Go Update"
              @click="navigateToUpdate(item)"
            >
              <b-icon-triangle aria-label="Update"></b-icon-triangle>
            </b-button>
            <b-button size="sm"
              variant="primary"
              class="mb-2"
              v-b-tooltip.hover.down title="Go View"
              @click="navigateToShow(item)"
            >
              <b-icon-asterisk aria-label="View"></b-icon-asterisk>
            </b-button>
          </b-button-group>
          <polymorphic-reference-card :data_item="item"></polymorphic-reference-card>
        </div>
      </b-card-group>
    </b-card>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import AmsSearch from './AmsSearch.vue'
import PolymorphicReferenceCard from './PolymorphicReferenceCard.vue'
import {
  BIconAsterisk,
  BIconTriangle,
  BIconPlusCircleFill,
} from 'bootstrap-vue'

export default {
  components: {
    BIconAsterisk,
    BIconTriangle,
    BIconPlusCircleFill,
    AmsSearch,
    PolymorphicReferenceCard
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      ams_type: 'polymorphic-references',
      link: "/" + this.ams_type + "/create",
      totalRows: 0,
      currentPage: 1,
      perPage: 0,
      items: [],
      included: [],
      ams_fields: [
        { 
          key: 'attributes.reference-to-type',
          label: 'ReferenceToType',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.relevance',
          label: 'Relevance',
          sortable: true,
          filterable: true,
          class: 'text-center',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.title',
          label: 'Title',
          sortable: true,
          filterable: true,
          class: 'text-center',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.url-link',
          label: 'URL Link',
          sortable: true,
          filterable: true,
          class: 'text-center',
          sortDirection: 'asc' 
        },
      ],
      search_params: undefined
    }
  },
  methods: {
    addEntry() {
      if(this.reroute_name) {
        this.$router.push( {
          name: this.reroute_name,
          params: {
            ams_template: this.ams_template
          }
        })
      }
      else {
        this.$router.push( {
          path: this.link
        })
      }
    },
    searchSelection(searchOptions) {
       this.search_params = searchOptions
       this.callApi()
    },
    callApi () {
      http_v1.get (
        'api/admin/v1/polymorphic_references', {
          params: {
            page: this.currentPage,
            ... this.filtering,
            ... this.search_params
          }
        }
      ).then(response => {
        if(response.status == 200) {
          this.totalRows = response.headers.total
          this.perPage = response.headers['per-page']
          this.items = response.data.data
          this.included = response.data.included
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.items = []
        this.totalRows = 0
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          window.console.log(message)
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    navigateToShow(data_item) {
      let nav = {
        name: 'PolymorphicReferenceShowScreen', 
        params: {
          id: data_item.id
        }
      }
      this.$router.push(nav)
    },
    navigateToUpdate(data_item) {
      let nav = {
        name: 'PolymorphicReferenceUpdateScreen', 
        params: {
          id: data_item.id
        }
      }
      this.$router.push(nav)
    }
  },
  watch: {
    currentPage() {
      this.callApi()
    },
    filtering : {
      handler() {
        this.callApi()
        this.$emit('refreshed', true)
      },
      deep: true
    }
  },
  mounted() {
    this.callApi()
  }
}
</script>
